// extracted by mini-css-extract-plugin
module.exports = {"container":"_3tXgRDT4BD57KzvWYjrYtO"};